import { render } from "./AddCasual.vue?vue&type=template&id=a762147c"
import script from "./AddCasual.vue?vue&type=script&lang=js"
export * from "./AddCasual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__